




































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Common } from '@/core/Common';
import { FView } from '@/core/FView';
import { DataType } from '@/core/data/DataType';
import { EnterExitColoredRecord } from '@/core/data/sets/computed/EnterExitColoredRecord';
import { EnterExitHourlyFormattedRecord } from '@/core/data/sets/computed/EnterExitHourlyFormattedRecord';
import TabEnterExit from '@/components/tabs/TabEnterExit.vue';

@Component ({
  components: {
      
  },
})
export default class extends Vue {
    @Prop({default: true}) showSpoilers!: boolean;

    dataSet: Record<string, Record<string, EnterExitColoredRecord>> | null = null;
    hourlyDataSet: Record<string, Record<string, Record<string, EnterExitHourlyFormattedRecord>>> | null = null;
    allHours: string[] = EnterExitHourlyFormattedRecord.getAllHours();
    openedDays: boolean[] = new Array(this.getAllDates().length).fill(false);
    lastDateCount: number = this.getAllDates().length;

    getDataSet() {
        if (this.dataSet == null) {
            this.dataSet = EnterExitColoredRecord.getColoredRecords();
        }
        return this.dataSet;
    }

    getHourlyDataSet() {
        if (this.hourlyDataSet == null) {
            this.hourlyDataSet = EnterExitHourlyFormattedRecord.getRecords();
        }
        return this.hourlyDataSet;
    }

    getAllPlaces() {
        return (this.$parent as TabEnterExit).filteredPlaces;
    }

    getAllDates() {
        return (this.$parent as TabEnterExit).filteredDates;
    }

    toggleDay(index: number) {
        this.openedDays[index] = !this.openedDays[index];
        this.$forceUpdate();
    }

    isDayOpened(index: number) {
        let newLength = this.getAllDates().length;
        if (newLength != this.lastDateCount) {
            this.lastDateCount = newLength;
            this.openedDays.fill(false);
        }
        return this.openedDays[index];
    }


    getRecord(date: string, place: string, hour: string | null = null) {
        if (hour == null) {
            return this.getDataSet()[date][place];
        } else {
            return this.getHourlyDataSet()[date][hour][place];
        }
    }

    
    getFormattedHour(time: string): string {
        return time.split(":").slice(0, 2).join(":");
    }

    getColumnCount() {
        return this.getAllPlaces().length + 1;
    }

    getSummForDate(date: string) {
        let summ = {
            in: 0,
            out: 0,
        };
        for (let place of this.getAllPlaces()) {
            let record = this.getDataSet()[date][place];
            if (record.in != null) {
                summ.in += record.in;
            }
            if (record.out != null) {
                summ.out += record.out;
            }
        }
        return summ;
    }

    getSummForHour(date: string, time: string) {
        let summ = {
            in: 0,
            out: 0,
        };
        for (let place of this.getAllPlaces()) {
            let record = this.getHourlyDataSet()[date][time][place];
            if (record.in != null) {
                summ.in += record.in;
            }
            if (record.out != null) {
                summ.out += record.out;
            }
        }
        return summ;
    }

    getSumm(place: string) {
        let summ = {
            in: 0,
            out: 0,
        };
        for (let date of this.getAllDates()) {
            let record = this.getDataSet()[date][place];
            if (record.in != null) {
                summ.in += record.in;
            }
            if (record.out != null) {
                summ.out += record.out;
            }
        }
        return summ;
    }

    getSummTotal() {
        let summ = {
            in: 0,
            out: 0,
        };
        for (let date of this.getAllDates()) {
            for (let place of this.getAllPlaces()) {
                let record = this.getDataSet()[date][place];
                if (record.in != null) {
                    summ.in += record.in;
                }
                if (record.out != null) {
                    summ.out += record.out;
                }
            }
        }
        return summ;
    }



    formatDate(dt: string): string {
        return Common.FormatDate(dt);
    }

    getColor(dt: string) {
        return Common.IsWeekend(dt) ? "#C11" : "#111"
    }
}
